import { Grid, Typography } from "@material-ui/core";

const StateRadonInfo = ({ reportDetails }) => {
  const {
    contact_email: email,
    contact_phone: phone,
    state_full_name: state,
    dep_web: url,
  } = reportDetails.ctrl_state_detail;

  return (
    <Grid container spacing={2} direction="column">
      <Grid item style={{ marginBottom: "5px" }}>
        <Typography
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          State Radon Information
        </Typography>
      </Grid>
      <Grid item>
        <Typography>
          More information about radon is available by contacting the Department
          of Health at:
        </Typography>
      </Grid>
      <Grid item>
        <Typography style={{ fontWeight: "bold", textDecoration: "underline" }}>
          {state.toUpperCase()}
        </Typography>
      </Grid>
      <Grid item container style={{ marginBottom: "10px" }}>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: "12px" }}
          >{`Phone: ${phone}`}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: "12px" }}
          >{`Website: ${url}`}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: "12px" }}
          >{`Email: ${email}`}</Typography>
        </Grid>
      </Grid>
      <Grid item style={{ marginBottom: "20px" }}>
        <Typography style={{ fontSize: "12px" }}>
          Radon levels in a home can be influenced by many factors including
          weather, season, living conditions, and occupancy patterns. Temporary
          conditions observed during the testing period may cause the test to
          not reflect the client’s risk from radon. The levels stated for this
          time period had the following situations present.
        </Typography>
      </Grid>
    </Grid>
  );
};
export default StateRadonInfo;
